import axios from './_nestAxios'

export const obtenerBloqueos = () => axios.get('/bloqueos-periodos')
